import React, { useRef, useEffect, useState } from 'react';
import { NotifyTypeEnum } from "src/constants/enums/notifyTypes";
import { useTranslation } from 'src/hooks/translation';

const classTypeMap = {
    [NotifyTypeEnum.Info]: 'info',
    [NotifyTypeEnum.Warning]: 'warning',
    [NotifyTypeEnum.Error]: 'error ',
    [NotifyTypeEnum.Success]: 'success',
};
const iconClassTypeMap = {
    [NotifyTypeEnum.Info]: 'filled-info',
    [NotifyTypeEnum.Warning]: 'reject-light',
    [NotifyTypeEnum.Error]: 'error ',
    [NotifyTypeEnum.Success]: 'success',
};

interface IProps {
    type: NotifyTypeEnum
    message: string | string[] | null,
    debounce?: boolean;
};

const NotifyMessageItem = ({ type, message, debounce }: IProps) => {
    const t = useTranslation();
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    const [show, setShow] = useState(false);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;

        if (message && debounce) {
            timeout = setTimeout(() => setShow(true), 350);
        } else setShow(!!message);

        return () => timeout && clearTimeout(timeout);;
    }, [message, debounce, timeoutRef]);

    if (!message || !show) return null;

    return (
        <div className={`B-${classTypeMap[type]}`}>
            <div className="B-betslip-notif-icon"><i className={`global-icon icon-${iconClassTypeMap[type]}`} /></div>
            <div className="B-betslip-notif-txt">
                <p className="B-betslip-notif-txt">{Array.isArray(message) ? t(...message) : t(message)}</p>
            </div>
        </div>
    )
}

export default NotifyMessageItem;